import { render, staticRenderFns } from "./EditTags.vue?vue&type=template&id=affac130&scoped=true&"
import script from "./EditTags.vue?vue&type=script&lang=js&"
export * from "./EditTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affac130",
  null
  
)

export default component.exports